import { useState } from "react";
import SendMail from "./sendMail";
import SendOTP from "./sendOTP";


function Login() {
  const [email, setEmail] = useState(null);
  const [step, setStep] = useState(1); //1: nhập email, 2: nhập otp

  if(step === 1){
    return (
      <SendMail setMail={(data) => setEmail(data)} setStep={() => setStep(2)}></SendMail>
    );
  } else {
    return (
      <SendOTP email={email}></SendOTP>
    );
  }
  
}

export default Login;